<template>
  <v-card :key="mode">
    <v-card>
      <v-card-text>
        <div bottom class="text-h5 text-center">{{ title }}</div>
      </v-card-text>
    </v-card>
    <v-card-text>
      <v-data-table :items="items" :headers="headers" :itemsPerPage="12" dense>
        <template v-if="editing" v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td>{{ item.number }}</td>
              <td>
                <v-text-field
                  dense
                  :hide-details="true"
                  :single-line="true"
                  v-model="item.description"
                  :id="'Row' + item.number.toString() + '_Description'"
                ></v-text-field>
              </td>
              <td>
                <v-menu
                  :ref="'from' + item.number.toString()"
                  v-model="item.showPicker_from"
                  :close-on-content-click="false"
                  :return-value.sync="item.editable_from"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      :hide-details="true"
                      :single-line="true"
                      v-model="item.from_formatted"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item.from" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="item.showPicker_from = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="fromEntered(item)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
              <td>
                <v-menu
                  :ref="'to' + item.number.toString()"
                  v-model="item.showPicker_to"
                  :close-on-content-click="false"
                  :return-value.sync="item.editable_to"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      :hide-details="true"
                      :single-line="true"
                      v-model="item.to_formatted"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="item.to" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="item.showPicker_to = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="toEntered(item)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "EstimationColumnEdit",

  components: {
    //
  },

  props: ["value", "title", "initialmode"],

  data: () => ({
    showPicker: false,
    editing: false,
    mode: null,
    items: [],
    headers: [
      { text: "Columna", value: "number", sortable: false },
      { text: "Descripción", value: "description", sortable: false },
      { text: "Habilitada Desde", value: "from_formatted", sortable: false },
      { text: "Habilitada Hasta", value: "to_formatted", sortable: false }
    ]
  }),

  methods: {
    fromEntered(item) {
      this.$refs["from" + item.number.toString()][0].save(item.from);
      item.from_formatted = this.formatDate(item.from);
    },

    toEntered(item) {
      this.$refs["to" + item.number.toString()][0].save(item.to);
      item.to_formatted = this.formatDate(item.to);
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async initialize(campaignId) {
      let template = [];
      let index = -1;
      for (let i = 1; i <= 12; i++) {
        template.push({
          campaign_id: campaignId,
          number: i,
          description: null,
          from: null,
          from_formatted: null,
          to: null,
          to_formatted: null,
          showPicker_from: false,
          showPicker_to: false
        });
      }
      //get stored data
      let stored = await this.$bRoot.search(
        "/data/estimations_columns",
        null,
        null,
        "campaign__id=" + campaignId.toString()
      );
      //merge results
      stored.data.results.map(item => {
        index = template.findIndex(
          template_item => template_item.number === item.number
        );
        template[index].description = item.description;
        template[index].from = this.$moment(item.editable_from).format(
          "YYYY-MM-DD"
        );
        template[index].from_formatted = this.$moment(
          item.editable_from
        ).format("DD/MM/YYYY");
        template[index].to = this.$moment(item.editable_to).format(
          "YYYY-MM-DD"
        );
        template[index].to_formatted = this.$moment(item.editable_to).format(
          "DD/MM/YYYY"
        );
      });
      this.items = template;
    },

    async save() {
      try {
        let item = {};
        let object = [];
        for (let i = 0; i <= 11; i++) {
          item = this.items[i];
          if (this.$bRoot.isNullOrEmpty(item, "description")) {
            throw "Fila " + item.number.toString() + ", ingrese descripción";
          }
          if (this.$bRoot.isNullOrEmpty(item, "from")) {
            throw "Fila " + item.number.toString() + ", ingrese fecha desde";
          }
          if (this.$bRoot.isNullOrEmpty(item, "to")) {
            throw "Fila " + item.number.toString() + ", ingrese fecha hasta";
          }
          object.push({
            campaign_id: this.value,
            number: item.number,
            description: item.description,
            editable_from: item.from + "T00:00:00-0300",
            editable_to: item.to + "T23:59:00-0300"
          });
        }
        await this.$bRoot.axios.put("/data/estimations_columns/bulk/", object);
        this.editing = false;
        this.mode = "show";
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
          return null;
        }
      }
    }
  },

  async mounted() {
    this.initialize(this.value);
    this.mode = this.initialmode;
    this.editing = this.mode === "edit" || this.mode == "new";
  },

  watch: {
    mode: {
      handler() {
        this.$emit("modeChange", this.mode);
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
.v-data-table {
  margin-top: 0px;
}
</style>
